import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/saemitalk/kakaotalk.png'
import _imports_1 from '../../assets/saemitalk/saemi_1.png'


const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Saemi Talk ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 뇌 운동에 도움을 주는 AI 친구   ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"#ffcc02"},
  class: "font-weight-bold"
}, " \"새미톡\" ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 새미는 ‘새미톡’을 상징하는 AI친구입니다. ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 신체운동을 할 때에도 코치가 필요한 것처럼 ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 뇌운동에도 도움을 주는 조력자의 역할은 큰 도움이 됩니다. ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 뇌운동은 꾸준히 할 수 있도록 도와주고 ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 지속적으로 격려해주는 AI친구 ‘새미’는 인공지능 분석을 통해 ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 여러분의 뇌운동을 꾸준히 할 수 있도록 돕는 귀여운 친구입니다. ")

import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, smAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "elevation-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_subtitle, {
        class: _normalizeClass(["font-weight-regular", { 'text-subtitle-1': _unref(xs), 'text-h6': _unref(smAndUp) }]),
        style: {"color":"#0a6cff","opacity":"1"}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_card_title, {
        class: _normalizeClass(["font-weight-medium", { 'text-h5 flex-column align-start': _unref(xs) }]),
        style: {"font-size":"2.25rem"}
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "7",
            class: "pr-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: _normalizeClass(["text-black pr-0", { 'saemiExplain xs': _unref(xs), 'text-body-1': _unref(smAndUp) }]),
                style: {"line-height":"1.5"}
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_card_text, {
                class: _normalizeClass(["text-black pr-0", { 'saemiExplain xs': _unref(xs), 'text-body-1': _unref(smAndUp) }]),
                style: {"line-height":"1.5"}
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_btn, {
                flat: "",
                rounded: "lg",
                color: "#FEE500",
                href: "http://pf.kakao.com/_bFExfj",
                target: "_blank",
                class: _normalizeClass(["font-weight-bold ma-3", { 'mb-8': _unref(smAndUp) }]),
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: _imports_0,
                    class: _normalizeClass(["kakaotalkLogo", { xs: _unref(xs) }])
                  }, null, 8, ["class"]),
                  _createElementVNode("p", {
                    class: _normalizeClass(["font-weight-bold", { 'linkToSaemi xs': _unref(xs) }])
                  }, " 새미톡 채널 바로가기 ", 2)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "pl-0, pb-0",
            "align-self": "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: _imports_1,
                class: _normalizeClass(["pr-5 saemitalkImage", { xs: _unref(xs) }])
              }, null, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})